import { useSelector } from "react-redux";
import { selectEmail } from "store/quote/selectors";
import { useStatsigPersistentUser } from "./use-statsig-persistent-user";
import { useEffect } from "react";
import { usePrevious } from "react-use";

export function useStatsigUpdatePersistentUserEmail() {
  const email = useSelector(selectEmail);
  const { updateStatsigPersistentUser } = useStatsigPersistentUser();
  const prevEmail = usePrevious(email);

  useEffect(() => {
    if (email && email !== prevEmail) {
      void updateStatsigPersistentUser({
        userID: email,
        email,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
}
